
import { defineComponent } from 'vue';
import Form from '../components/Form.vue';
import Task from '../components/Task.vue';
import Box from '../components/Box.vue';
import ITask from '../interfaces/ITask';

export default defineComponent({
  name: "App",
  components: {
    Form,
    Task,
    Box
  },
  data() {
    return {
      taskItems: [] as ITask[]
    }
  },
  computed: {
    isListEmpty(): boolean {
      return this.taskItems.length === 0;
    }
  },
  methods: {
    saveTask(task: ITask) {
      this.taskItems.push(task);
    }
  }
});
